import { CollectionState } from "@/components/CollectionsPage/redux/types";

const collectionInitialState: CollectionState = {
  collectionData: {
    userInfo: null,
  },
  loading: false,
  error: null,
};

export default collectionInitialState;
